module.exports = __webpack_public_path__ + "static/media/mango-seller.f94bfccc.PNG";